import { defineAsyncComponent, hydrateOnVisible } from 'vue'

import ParagraphTypeEpgSearch from './theme/ParagraphTypeVueComponent/ParagraphTypeEpgSearch.vue'
import BrandTeaser from './theme/BrandTeaser.vue'

const ParagraphTypeVodSearch = defineAsyncComponent({
  loader: () => import('./theme/ParagraphTypeVueComponent/ParagraphTypeVodSearch.vue'),
  hydrate: hydrateOnVisible()
})

const registerBrandVueComponents = (app) => {
  app.component('ParagraphTypeVodSearch', ParagraphTypeVodSearch)
  app.component('ParagraphTypeEpgSearch', ParagraphTypeEpgSearch)
  app.component('BrandTeaser', BrandTeaser)
}

export {
  registerBrandVueComponents
}
